
import { Component, Vue } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { getMyData } from '@/services/user.service'
import { getMpData, unBindMp } from '@/services/mp.service'

@Component({
  components: {
    SellerHeader,
  },
})
export default class Profile extends Vue {
  public mpObjet
  mpUrl: any = ''
  public user: any = []
  public initials = ''
  public copyMessage =
    'Te comparto mi código de vendedor para comprar los tickets: '
  public isSuperAdmin = false

  copyToClipBoard() {
    navigator.clipboard.writeText(this.mpUrl).then(
      function() {
        Vue.$toast.success(`Mensaje copiado!`)
      },
      function() {
        Vue.$toast.error(`Error copiando mensaje! Intenta nuevamente`)
      }
    )
  }

  async beforeMount() {
    // const { data } = await getMpData()
    // this.mpUrl = data.url
  }

  async unBindMp() {
    await unBindMp()
    Vue.$toast.success(`Ya estas desvinculado!`)
    const response = await getMpData()
    const mpData = response.data
    this.mpUrl = mpData.url
  }

  async mounted() {
    try {
      const { data } = await getMyData()

      this.user = data
      this.user.notification_email =
        this.user.notification_email != null
          ? this.user.notification_email
          : this.user.email
      this.isSuperAdmin = data.role_id == 7 ? true : false
      this.initials = data.fullname.charAt(0)
    } catch (e) {
      console.log(e)
    }
  }
}
